module.exports = __webpack_public_path__ + "static/media/25488324_1703516983056819_3463088270184881341_o.358c2e3a.jpg";